define('score_bootstrap/Models/Comments/CommentsClient',[
    "jquery",
    "errorHandler",
    "score_bootstrap/Models/Comments/CommentsRequest",
    "score_bootstrap/Models/Comments/PostCommentModel"
], function ($, errorHandler, CommentsRequest, PostCommentModel) {

    function CommentsClient(commentsUrl, postCommentUrl) {

        Object.defineProperties(this, {
            commentsUrl: { value: commentsUrl },
            postCommentUrl: { value: postCommentUrl }
        });
    }

    CommentsClient.prototype.getComments = function getComments(componentId, pageNumber, pageSize, 
        showMoreEnabled, orderByAscending, maximumCascadedReplies, userLanguage, rootId) {

        var commentsRequest = new CommentsRequest(componentId,
            pageNumber,
            pageSize,
            showMoreEnabled,
            orderByAscending,
            maximumCascadedReplies,
            userLanguage,
            rootId);

        var jqXHR = $.ajax({
            url: this.commentsUrl,
            data: JSON.stringify(commentsRequest),
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json"
        });

        jqXHR.fail(errorHandler.logError);

        return jqXHR;
    }

    CommentsClient.prototype.postComment = function postComment(id, componentId, commentText, postDate, rootId, postCommentAction, userTimeOffset, userLanguage) {
        var postCommentModel =
            new PostCommentModel(id, componentId, commentText, postDate, rootId, postCommentAction, userTimeOffset, userLanguage);
        var jqXHR = $.ajax({
            url: this.postCommentUrl,
            data: JSON.stringify(postCommentModel),
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json"
        });

        jqXHR.fail(errorHandler.logError);

        return jqXHR;
    }

    return CommentsClient;
});
